const tenantConfig = {
  localhost: {
    API_URL: "https://api.rameesystems.com",
    BASE_URL: "http://localhost:3000",
    REACT_APP_HOMEPAGE_URL: "http://localhost:3000",
    PREFIX: "ayt",
  },
  "ddsnacks.co.uk": {
    API_URL: "https://testapi.rameegroup.co.in",
    BASE_URL: "https://ddsnacks.co.uk",
    REACT_APP_HOMEPAGE_URL: "https://ddsnacks.co.uk",
    PREFIX: "dds",
  },
  "dan.rameegroup.co.in": {
    API_URL: "https://testapi.rameegroup.co.in",
    BASE_URL: "https://dan.rameegroup.co.in",
    REACT_APP_HOMEPAGE_URL: "https://dan.rameegroup.co.in",
    PREFIX: "dan",
  },
  "karoon.rameegroup.co.in": {
    API_URL: "https://testapi.rameegroup.co.in",
    BASE_URL: "https://karoon.rameegroup.co.in",
    REACT_APP_HOMEPAGE_URL: "https://karoon.rameegroup.co.in",
    PREFIX: "knm",
  },
  "tsdev.rameegroup.co.in": {
    API_URL: "https://testapi.rameegroup.co.in",
    BASE_URL: "https://tsdev.rameegroup.co.in",
    REACT_APP_HOMEPAGE_URL: "https://tsdev.rameegroup.co.in",
    PREFIX: "tsc",
  },
  "aytac.rameesystems.com": {
    API_URL: "https://api.rameesystems.com",
    BASE_URL: "https://aytac.rameesystems.com",
    REACT_APP_HOMEPAGE_URL: "https://aytac.rameesystems.com",
    PREFIX: "ayt",
  },
  "kmfood.co.uk": {
    API_URL: "https://api.rameesystems.com",
    BASE_URL: "https://kmfood.co.uk",
    REACT_APP_HOMEPAGE_URL: "https://kmfood.co.uk",
    PREFIX: "knm",
  },
  "tsc.ebusso.com": {
    API_URL: "https://api.rameesystems.com",
    BASE_URL: "https://tsc.ebusso.com",
    REACT_APP_HOMEPAGE_URL: "https://tsc.ebusso.com",
    PREFIX: "tss",
  },
  "dds.ebusso.com": {
    API_URL: "https://api.rameesystems.com",
    BASE_URL: "https://dds.ebusso.com",
    REACT_APP_HOMEPAGE_URL: "https://dds.ebusso.com",
    PREFIX: "ddd",
  },
  "daninternational.rameesystems.com": {
    API_URL: "https://api.rameesystems.com",
    BASE_URL: "https://daninternational.rameesystems.com",
    REACT_APP_HOMEPAGE_URL: "https://daninternational.rameesystems.com",
    PREFIX: "dan",
  },
  "everest.rameesystems.com": {
    API_URL: "https://api.rameesystems.com",
    BASE_URL: "https://everest.rameesystems.com",
    REACT_APP_HOMEPAGE_URL: "https://everest.rameesystems.com",
    PREFIX: "eve",
  },
};

// Fetch configuration url
const currentURL = window.location.hostname;
const tenant = tenantConfig[currentURL] || tenantConfig["localhost"];

const ApiConfig = {
  API_URL: tenant.API_URL,
  BASE_URL: tenant.BASE_URL,
  REACT_APP_HOMEPAGE_URL: tenant.REACT_APP_HOMEPAGE_URL,
  PREFIX: tenant.PREFIX,

  // Auth Apis
  login: `${tenant.API_URL}/ws-login-v2`,
};

export default ApiConfig;

